function initSummernote(id, placeholder, afterInit, changeCallback){
	let tempEditor = $('#' + id);

	if(tempEditor.length){
		tempEditor.summernote('destroy');

		tempEditor.summernote({
			placeholder: placeholder,
			height: 250,
			toolbar: [
				['style', ['style']],
				['font', ['bold', 'underline', 'clear']],
				['fontname', ['fontname']],
				['color', ['color']],
				['para', ['ul', 'ol', 'paragraph']],
				['table', ['table']],
				['insert', ['link', 'picture']],
				['view', ['codeview']],
			],
			callbacks:{
				onChange: (contents) =>{
					changeCallback(contents)
				},
			}
		});

		afterInit();
	}
}

function setSummernoteContent(id, value){
	let tempEditor = $('#' + id);
	
	tempEditor.summernote('code', value);
}